<template>
  <div class='data-search'>
    <Header :header="$t('integration.data_conditions')" />
    <div class='m-c-search'>
      <el-form inline :model='form' ref='form' :rules='rules'>
        <el-form-item :label="$t('integration.start')" prop='start'>
          <el-date-picker type='datetime' :placeholder="$t('integration.select_date')" v-model='form.start'
                          value-format='timestamp' style='width: 208px'></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('integration.end')" prop='end'>
          <el-date-picker type='datetime' :placeholder="$t('integration.select_date')" v-model='form.end'
                          value-format='timestamp' style='width: 208px'></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('integration.data')" prop='data'>
          <el-select v-model='form.data' multiple style='width: 208px'
                     :placeholder="$t('integration.please_select')" @change='changeFn'>
            <el-option v-for='item in options' :key='item.code' :label='item.content' :value='item.code'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('integration.file')" prop='file'>
          <el-select v-model='form.file' style='width: 208px' :placeholder="$t('integration.please_select')"
                     @change='changeFileFn'>
            <el-option v-for='item in fileArray' :key='item.code' :label='item.content' :value='item.code'>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-button type='primary' class='btn-export driver-item-export-data' @click='exportData'>
        {{ $t('integration.export_data') }}
      </el-button>
    </div>

    <exportDialog :isShow.sync='exportDiaShow' :searchForm='eForm' ref='dia' :comNmae='exportDatas'></exportDialog>
  </div>
</template>
<script>
import { exportDatas } from '@/api/modules/dataDetail.js'
import { conditionRule } from '../config/rules'
import { shareParam } from '@/api/modules/public.js'
import Header from '../../component/Header.vue'
import exportDialog from '../../component/exportDialog.vue'
import bus from '@/utils/bus'

export default {
  props: ['form', 'carrierList'],
  computed: {
    rules () {
      return conditionRule.call(this)
    },
    // 需要导出的监测点参数
    exportCarriers () {
      return this.carrierList.map(item => item.id).join(',')
    }
  },
  data () {
    return {
      fileArray: [],
      options: [],
      exportDiaShow: false,
      eForm: {},
      exportDatas
    }
  },
  created () {
    this.getAlaTypes()
  },
  components: {
    Header,
    exportDialog
  },
  methods: {
    getAlaTypes () {
      ['probe_data_type', 'export_file_type'].forEach(code => {
        shareParam({
          code,
          type: 0
        }).then(({ result }) => {
          if (code === 'probe_data_type') {
            // this.options = result.filter(item => {
            //   if (item.content === 'temp' || item.content === 'hum') {
            //     return true
            //   } else {
            //     return false
            //   }
            // })
            // this.options = this.options.map(item => ({
            //   code: item.code,
            //   content: this.$t('sensor.' + item.content),
            //   name: item.content
            // }))
            // 
            this.options = result.filter(item => {
              if (item.content !== 'volt' && item.content !== 'rssi' && item.content !== 'lqi') {
                return true
              } else {
                return false
              }
            })
            this.options = this.options.map(item => ({
              code: item.code,
              content: this.$t('sensor.' + item.content),
              name: item.content
            }))
          } else {
            this.fileArray = result.map(item => ({
              code: item.code,
              content: this.$t('analysis.' + item.content)
            }))
          }
        })
      })
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async exportData () {
      const falg = await this.justify()
      if (!falg) return
      if (!this.carrierList.length) return this.$message.warning($t('integration.please_select_a_monitoring_point'))
      this.exportDiaShow = true
      const {
        start,
        end,
        file,
        data
      } = this.form
      this.eForm = {
        startTime: start,
        endTime: end,
        file,
        types: data.join(','),
        carrierIds: this.exportCarriers
      }
      this.$nextTick(() => {
        this.$refs.dia.initForm()
      })
    },
    changeFn (array) {
      const tabArray = this.options.filter(item => array.includes(item.code))
      bus.$emit('dataValFn', tabArray)
    },
    changeFileFn (num) {
      bus.$emit('changeFileFn', num)
    }
  }
}
</script>

<style scoped lang='scss'>
.data-search {
  width: 100%;
  height: 300px;
  // padding-bottom: 2px;
  border-bottom: 1px solid #cccccc;
  box-sizing: border-box;
  position: relative;

  .btn-export {
    position: absolute;
    bottom: 2px;
    left: 0px;
    right: 0px;
  }
}

.m-c-search {
  padding: 10px;
  padding-bottom: 0;
}
</style>
